export default "__VITE_ASSET__BBVn5bm2__"